module.exports = __webpack_public_path__ + "assets/img/behaviorscreenshot.7ced7443.svg";